import { SidebarBrand } from "./SidebarBrand";
import { SidebarNav } from "./SidebarNav";

export function Sidebar() {
  return (
    <aside className="hidden w-60 shrink-0 bg-adara-800 lg:flex lg:flex-col">
      <div className="flex h-14 shrink-0 items-center border-b border-white/10 px-5">
        <SidebarBrand />
      </div>

      <SidebarNav />
    </aside>
  );
}
